import { render, staticRenderFns } from "./NavbarX.vue?vue&type=template&id=4ec76534&scoped=true"
import script from "./NavbarX.vue?vue&type=script&lang=js"
export * from "./NavbarX.vue?vue&type=script&lang=js"
import style0 from "./NavbarX.vue?vue&type=style&index=0&id=4ec76534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec76534",
  null
  
)

export default component.exports